import { getCurrentScope as SentryGetCurrentScope } from '@sentry/react';

export const DEFAULT_SENTRY_USER_TYPE = 'UNKNOWN';
export const RECAPTCHA_KEY_UNDEFINED_ERROR_MESSAGE = 'recaptchaKey undefined';

/**
 * Detects Firebase Auth's known noisy reCAPTCHA config error.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export const isRecaptchaKeyUndefinedError = (error) => {
  const normalise = (value) => value.toLowerCase();
  const targetMessage = normalise(RECAPTCHA_KEY_UNDEFINED_ERROR_MESSAGE);

  if (typeof error === 'string') {
    return normalise(error).includes(targetMessage);
  }

  if (error instanceof Error) {
    return normalise(error.message).includes(targetMessage);
  }

  if (typeof error !== 'object' || error === null || !('message' in error)) {
    return false;
  }

  return typeof error.message === 'string' && normalise(error.message).includes(targetMessage);
};

export const updateUserScopeInSentry = ({ userId = '', userType = DEFAULT_SENTRY_USER_TYPE } = {}) => {
  SentryGetCurrentScope().setUser(
    userId
      ? {
          id: userId,
          userType,
        }
      : null,
  );

  SentryGetCurrentScope().setTags({ userType });
};
